<template>
	<v-container fluid>
		<v-row class="pa-3">
			<v-btn color="error" @click="backClick" class="ml-0">
				<v-icon small>fa-reply</v-icon>&nbsp;{{ $t('buttons.back') }}
			</v-btn>
			<v-btn color="success" @click="saveClick(null)" class="ml-2">
				<v-icon small>fa-save</v-icon>&nbsp;{{ $t('buttons.save') }}
			</v-btn>
		</v-row>
		<v-row>
			<v-col lg="6" md="8" cols="12">
				<v-card outlined flat>
					<v-card-text>
						<v-row wrap>
							<v-col cols="12">
								<InputField
									v-model="building.code"
									:error="buildingValidation.code"
									:label="'* '+$t('fields.code')"></InputField>
							</v-col>
							<v-col cols="12" sm="8">
								<InputField
									v-model="building.street_and_no"
									:error="buildingValidation.street_and_no"
									:label="'* '+$t('fields.streetAndNo')"></InputField>
							</v-col>
							<v-col cols="12" sm="4">
								<InputField
									v-model="building.postal_code"
									:error="buildingValidation.postal_code"
									:label="$t('fields.postalCode')"></InputField>
							</v-col>
							<v-col cols="12" sm="8">
								<InputField
									v-model="building.city"
									:error="buildingValidation.city"
									:label="'* '+$t('fields.city')"></InputField>
							</v-col>
							<v-col cols="12" md="12">
								<InputField
									v-model="building.country"
									:error="buildingValidation.country"
									:label="'* '+$t('fields.country')"></InputField>
							</v-col>
							<v-col cols="12" lg="12">
								<CheckBox
									v-model="building.active"
									:label="$t('fields.active')"></CheckBox>
							</v-col>
						</v-row>
					</v-card-text>
				</v-card>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
import InputField from "./trinkets/InputField"
import CheckBox from "./trinkets/CheckBox";
import Building from "../models/Building";

export default {
	name: "Building",
	components: {CheckBox, InputField},
	data: function () {
		return {
			building: new Building({id: this.$route.params.id}),
			buildingValidation: new Building({}, true),
			initialLoad: false,
			changesHappened: false
		}
	},
	watch: {
		building: {
			handler: function () {
				if (this.initialLoad) {
					this.changesHappened = true;
				}
			},
			deep: true
		},
	},
	methods: {
		backClick() {
			this.$router.go(-1);
		},
		saveClick(after = null) {
			let success = true;

			if (this.building.code == '') {
				success = false;
				this.buildingValidation.code = this.$t('alerts.fieldMissing');
			} else {
				this.buildingValidation.code = '';
			}

			if (this.building.street_and_no == '') {
				success = false;
				this.buildingValidation.street = this.$t('alerts.fieldMissing');
			} else {
				this.buildingValidation.street = '';
			}

			if (this.building.city == '') {
				success = false;
				this.buildingValidation.city = this.$t('alerts.fieldMissing');
			} else {
				this.buildingValidation.city = '';
			}

			if (this.building.country == '') {
				success = false;
				this.buildingValidation.country = this.$t('alerts.fieldMissing');
			} else {
				this.buildingValidation.country = '';
			}

			if (success) {
				let vm = this;
				let action = 'post';
				let addition = '';
				if (vm.building.id != 0) {
					action = 'put';
					addition = '/' + vm.building.id;
				}
				this.$APICall(action, 'buildings' + addition, this.building, (data, success) => {
					if (success) {
						vm.changesHappened = false;
						if (vm.building.id == 0) {
							vm.$notify(vm.$t('alerts.basicAdd'));
						} else {
							vm.$notify(vm.$t('alerts.basicUpdate'));
						}
						vm.$triggerReload();
						if (after !== null) {
							after();
						} else {
							vm.backClick();
						}
					} else {
						vm.$alert(vm.$t('alerts.buildingExists'));
					}
				});
			}
		}
	},
	mounted() {
		if (!this.$myStore.state.loggedIn) {
			this.$router.replace('login');
		}
		let vm = this;
		if (this.building.id != 0) {
			this.$APICall('get', 'buildings/' + this.building.id, {}, (data, success) => {
				if (success) {
					let usableData = JSON.parse(JSON.stringify(data));
					vm.$myStore.commit('setBreadcrumbs', [
						{text: vm.$t('modules.buildings'), href: '/#/buildings', disabled: false},
						{text: vm.building.email, href: '/#/buildings/' + vm.building.id, disabled: true}
					]);
					vm.$nextTick(() => {
						vm.initialLoad = true;
					});
					vm.building = usableData;
				}
			});
		} else {
			this.$myStore.commit('setBreadcrumbs', [
				{text: this.$t('modules.buildings'), href: '/#/buildings', disabled: false},
				{text: this.$t('modules.newBuilding'), href: '/#/buildings/0', disabled: true}
			]);
			this.initialLoad = true;
		}
	},
	beforeRouteLeave(to, from, next) {
		if (this.changesHappened) {
			this.$verify(this.$t('alerts.leaveQuestion'), (result) => {
				next(result);
			});
		} else {
			next(true);
		}
	}
}
</script>

<style scoped>

</style>
